import { DefaultRebateIcon } from '@airship-platform/jam-web/icons';
import { ProductCard } from '../../add-products';
import { PropsWithChildren } from 'react';
import { DiscountAndFee } from '../../../data-access';
import { PercentageSection, PriceSectionEditable } from '../../add-products';

interface ModifierCardProps {
  modifier: Pick<
    DiscountAndFee,
    | 'discountsAndFeesId'
    | 'amountType'
    | 'images'
    | 'displayName'
    | 'description'
    | 'amount'
    | 'taxable'
  >;
}

const ModifierCard: React.FC<PropsWithChildren<ModifierCardProps>> = ({
  modifier,
  children,
}) => (
  <ProductCard
    key={modifier.discountsAndFeesId}
    product={{
      images: modifier.images,
      name: modifier.displayName,
      description: modifier.description,
    }}
    noImageIcon={<DefaultRebateIcon />}
    priceSection={
      modifier.amountType === 'PERCENTAGE' ? (
        <PercentageSection value={modifier.amount * 100} prefix="-" />
      ) : (
        <PriceSectionEditable
          defaultPriceType={'STANDARD'}
          prices={[
            {
              value: modifier.amount,
              currency: 'USD',
              priceType: 'STANDARD',
              taxable: modifier.taxable,
            },
          ]}
          startAdornment="-"
        />
      )
    }
    productClickRoute={`${modifier.discountsAndFeesId}`}
  >
    {children}
  </ProductCard>
);
export default ModifierCard;
